import { render, staticRenderFns } from "./DesignMore.vue?vue&type=template&id=0fcd48eb&scoped=true&"
import script from "./DesignMore.vue?vue&type=script&lang=js&"
export * from "./DesignMore.vue?vue&type=script&lang=js&"
import style0 from "./DesignMore.vue?vue&type=style&index=0&id=0fcd48eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcd48eb",
  null
  
)

component.options.__file = "DesignMore.vue"
export default component.exports